import {Trans} from '@lingui/macro';
import React from 'react';

export function renderSignatureChannelsDropdownAllIndividualChannelsLabel() {
  return <Trans id="signatures-channels-dropdown-all-individual">All individual channels</Trans>;
}

export function renderSignatureChannelsDropdownAllTeamChannelsLabel() {
  return <Trans id="signatures-channels-dropdown-all-team">All team channels</Trans>;
}

export function renderSignatureChannelsDropdownAllChannelsLabel() {
  return <Trans id="signatures-channels-dropdown-all">All channels</Trans>;
}
